const fonts = {
	sans: {
		name: '"Open Sans"',
		large: '40px',
		light: 300,
		regular: 400,
		semi: 600,
		bold: 700,
	},
	roboto: {
		name: '"Roboto"',
		thin: 100,
		light: 300,
		regular: 400,
		medium: 500,
		bold: 700,
		black: 900,
	},
}

export default fonts
